import { Component, OnInit, NgZone, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
//import { NetworkServicesService } from 'src/app/networkCalls/network-services.service';
import { Title, Meta } from '@angular/platform-browser';
// import { katanaInput } from 'src/app/models/katana-input.service';
// import { katanaResult } from 'src/app/models/katana-result.service';
// import { CKEditorComponent } from 'ngx-ckeditor';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
//import { Observable, from } from 'rxjs';
// import { MatDialog } from '@angular/material';
// import { ErrorModalComponent } from '../error-modal/error-modal.component';
// import { ProgressStatusService } from '../../services/progress-status-service'
//import { rejectError } from 'src/app/models/reject-suggetions.service';
// import { NGXLogger } from 'ngx-logger';
// import { acceptError } from 'src/app/models/accept-suggetions.service';
// import { trigger, transition, style } from '@angular/animations';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
//import { MatRadioChange } from '@angular/material/radio';
//import { start } from 'repl';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-sentence-checker',
  templateUrl: './sentence-checker.component.html',
  styleUrls: ['./sentence-checker.component.scss']
})
export class SentenceCheckerComponent implements  OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    // public dialog: MatDialog,
    // public progressStatusService: ProgressStatusService,
    // private errorModalComponent: ErrorModalComponent,
    public lc: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
    // private logger: NGXLogger,
  ) {
    //window.addEventListener("message", (d)=>{this.listenWindowMessage(d)});
  }

  ngOnInit() {
    // ele.classList.remove("loading")
    this.titleService.setTitle("無料オンライン英文チェッカー | AI英文校正ツールTrinka");
    this.metaTagService.updateTag({ name: 'description', content: "Trinkaの無料オンライン英文チェッカーで、英文の文法やスペルが正しいかをその場でチェック。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "無料オンライン英文チェッカー | AI英文校正ツールTrinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinkaの無料オンライン英文チェッカーで、英文の文法やスペルが正しいかをその場でチェック。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/sentence-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '無料オンライン英文チェッカー | AI英文校正ツールTrinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinkaの無料オンライン英文チェッカーで、英文の文法やスペルが正しいかをその場でチェック。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/sentence-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/sentence-checker' });
    if (isPlatformBrowser(this.platformId)) {
      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        $("#GCChromeButton1").css("display", "none");
        $("#GCFirFoxButton1").css("display", "none");
        $("#GCEdgeButton1").css("display", "none");
        return 'Opera';

      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        $("#GCChromeButton1").css("display", "block");
        $("#GCFirFoxButton1").css("display", "none");
        $("#GCEdgeButton1").css("display", "none");
        return 'Chrome';

      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        $("#GCChromeButton1").css("display", "none");
        $("#GCFirFoxButton1").css("display", "none");
        $("#GCEdgeButton1").css("display", "none");

        return 'Safari';

      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        $("#GCChromeButton1").css("display", "none");
        $("#GCFirFoxButton1").css("display", "block");
        $("#GCEdgeButton1").css("display", "none");
        return 'Firefox';

      }
      else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
        $("#GCChromeButton1").css("display", "none");
        $("#GCFirFoxButton1").css("display", "none");
        $("#GCEdgeButton1").css("display", "block");
        return 'IE';
      }
      else {
        return 'unknown';
      }
    }

    if (isPlatformServer(this.platformId)) {
      let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `{"name":"無料オンライン英語チェッカー","@type":"Product","brand":{"name":"トリンカ","@type":"Brand"},"gtin8":"","image":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg","@context":"https://schema.org/","description":"Trinkaの無料オンライン英文チェッカーで、英文の文法やスペルが正しいかをその場でチェック。","aggregateRating":{"@type":"AggregateRating","bestRating":"5","ratingCount":"25545","ratingValue":"4.5","worstRating":"1"}}`;

      this._renderer2.appendChild(this._document.head, script);

      let script1 = this._renderer2.createElement('script');
      script1.type = `application/ld+json`;
      script1.text = `
      {"@context":"https://schema.org","@type":"WebPage","name":"無料オンライン英文チェッカー | AI英文校正ツールTrinka","url":"https://www.trinka.ai/jp/sentence-checker","description":"Trinkaの無料オンライン英文チェッカーで、英文の文法やスペルが正しいかをその場でチェック。","image":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg"}
      `;

      this._renderer2.appendChild(this._document.head, script1);

      let script2 = this._renderer2.createElement('script');
      script2.type = `application/ld+json`;
      script2.text = `
      {"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"AI英文校正ツールTrinka |学術英語に強いAIが英文添削","item":"https://www.trinka.ai/jp/"},{"@type":"ListItem","position":2,"name":"英文チェッカー","item":"https://www.trinka.ai/jp/sentence-checker"}]}
      `;

      this._renderer2.appendChild(this._document.head, script2);

      let script3 = this._renderer2.createElement('script');
      script3.type = `application/ld+json`;
      script3.text = `
      {"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"自分の文章が正しいかどうか、どうすればチェックできますか？","acceptedAnswer":{"@type":"Answer","text":"このページの冒頭にある入力枠に英文を貼り付け、「修正結果を見る」をクリックするだけです。Trinkaがすべての文型と用法の誤りをハイライトし、文脈に応じた的確な提案をします。"}},{"@type":"Question","name":"自分が書いた英文の文法チェックを行うにはどうすればいいですか？","acceptedAnswer":{"@type":"Answer","text":"AI英文チェックツールTrinkaを使えば、わずか数クリックで、文法や句読点の間違い、単語の用法などがチェックでき、英文の見直しが可能です。"}},{"@type":"Question","name":"Trinkaの英文チェックツールは無料で使えますか？","acceptedAnswer":{"@type":"Answer","text":"もちろんです。このページ冒頭の入力枠に英文を貼り付けて「修正結果を見る」をクリックすると、英語の文章をチェックしたり修正したりできます。300単語以上の英文をチェックしたい場合は、Trinkaにご登録、より多くの機能を無料でご利用いただけます。"}},{"@type":"Question","name":"ウェブサイトの英文をチェックできますか？","acceptedAnswer":{"@type":"Answer","text":"はい、できます。Chrome、Firefox、Edgeブラウザプラグインをインストール、どのウェブサイトでもTrinkaを使うことができます。"}}]}
      `;

      this._renderer2.appendChild(this._document.head, script3);

      
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  

}
